import type { ReactNode } from "react";
import { PageHero } from "./PageHero";
import { SiteLayout } from "./SiteLayout";

type LegalSection = {
  title: string;
  content: ReactNode;
};

type LegalPageProps = {
  currentPage: string;
  eyebrow: string;
  title: string;
  description: string;
  updated: string;
  sections: LegalSection[];
};

export function LegalPage({ currentPage, eyebrow, title, description, updated, sections }: LegalPageProps) {
  return (
    <SiteLayout>
      <PageHero currentPage={currentPage} eyebrow={eyebrow} title={title} description={description} />
      <section className="page-section page-section-white">
        <div className="container legal-layout">
          <aside className="legal-aside"><strong>Last updated</strong><span>{updated}</span></aside>
          <div className="legal-body">
            {sections.map((section) => <section key={section.title}><h2>{section.title}</h2>{section.content}</section>)}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
